//File to view or edit the daily log details

import React, { useState, useEffect, ChangeEvent, useRef } from 'react';
import { Box, Button, Grid, IconButton, TextField, Typography, Menu, MenuItem, useTheme, Tooltip, } from '@mui/material';
import BasicTable, { Column } from '../../components/table';
import axios from 'axios';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link, Navigate } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";
import Select from '@mui/material/Select';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme/theme';
import { SelectChangeEvent } from '@mui/material/Select';
import SignatureCanvas from 'react-signature-canvas'; // Import SignatureCanvas
import { Backdrop, CircularProgress, } from "@mui/material";
//import { Attachment } from '@mui/icons-material';
import { BASEURL, ARROW, SIGN_FONT, IMAGEURL, FONT_SIZE, AUTOFILL_STYLES, ConfirmationDialog } from "../../constants/Common"
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';


interface EditedLog {
  id?: number;
  title?: string;
  status?: string;
  assignedto?: string;
  description?: string;
  projectname?: string;
  project_id?: string;
  createdby?: string;
  createddate?: string;
  remarks?: string;
  attachments?: string | null;
  signature: string;
  initials: string;
}

interface ProgressUpdate {
  id: number;
  createddate: string;
  createdby: string;
  remarks: string;
  trackingid: number;
  attachments: string | null;
  attachments2: string | null;
  attachments3: string | null;
  attachments4: string | null;
  attachments5: string | null;
  attachments6: string | null;
  signature: string;
  initials: string;

}


interface ProjectNames {
  id: number;
  project_name: string;
  project_status: string;
}


const DailyLogEdit = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [isEditMode, setIsEditMode] = useState(false);
  const [editedLog, setEditedLog] = useState<EditedLog | null>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [progressUpdates, setProgressUpdates] = useState<ProgressUpdate[]>([]);
  const location = useLocation();
  const [selectedLog, setSelectedLog] = useState<EditedLog>();

  // Define signatureRef using useRef hook
  const signatureRef = useRef<SignatureCanvas>(null);
  const [signatureData, setSignatureData] = useState<string>('');
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState<string[]>([]); // Users assigned to the selected project
  const orgid = localStorage.getItem('orgid');
  const userid = localStorage.getItem('userid');
  const mergedListRef = useRef(0);
  const [isSaving, setIsSaving] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const userraccess = JSON.parse("" + localStorage.getItem('userrole'));
  const moduleAccess = userraccess?.modulesaccess;
  let blnChangeFlag = false;
  const subscriptionstatus = localStorage.getItem('subscriptionstatus');

  useEffect(() => {
    const fetchProgressUpdates = async () => {
      try {
        const upd_url = BASEURL + '/progressupdate/';
        const response = await axios.get(upd_url, {
          headers: { Accept: 'application/json', },
        });

        setProgressUpdates(response.data.progress_update);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProgressUpdates();

  }, []);

  // useEffect(() => {

  //   //Get the selected log details to edit and store in editedLog variable
  //   let argLogData = location?.state;
  //   let logDetails = argLogData.logDetails

  //   if (logDetails !== undefined) {
  //     if (editedLog == null) {
  //       setEditedLog(logDetails as EditedLog)
  //       //      setSelectedLog(logDetails)
  //     }
  //   }
  //   else {
  //     if (selectedLog) {
  //       setEditedLog(selectedLog as EditedLog);
  //     } else {
  //       setEditedLog(null);
  //     }
  //   }

  //   //Get the projectnames list to display in project name dropdown
  //   let l_projectNamesData = argLogData.projectNamesData
  //   if (l_projectNamesData != undefined) {
  //     setProjectNamesData(l_projectNamesData)
  //   }
  //   if (mergedListRef.current === 0 && editedLog?.project_id) {  //use this condition to fetch and populate list only one time
  //     fetchAssignedUsers(editedLog.project_id);
  //     mergedListRef.current = 1
  //   }
  // }, [selectedLog, projectNamesData]);

  useEffect(() => {
    // Check if location.state is defined
    const argLogData = location?.state;
  
    if (argLogData) {
      const logDetails = argLogData.logDetails;
  
      if (logDetails !== undefined) {
        if (!editedLog) {
          setEditedLog(logDetails as EditedLog);
          // setSelectedLog(logDetails);
        }
      } else if (selectedLog) {
        setEditedLog(selectedLog as EditedLog);
      } else {
        setEditedLog(null);
      }
  
      // Get the project names list to display in the project name dropdown
      const l_projectNamesData = argLogData.projectNamesData;
      if (l_projectNamesData !== undefined) {
        setProjectNamesData(l_projectNamesData);
      }
  
      if (mergedListRef.current === 0 && editedLog?.project_id) {
        // Use this condition to fetch and populate the list only one time
        fetchAssignedUsers(editedLog.project_id);
        mergedListRef.current = 1;
      }
    } else {
      // Handle cases where location.state is null or undefined
      setEditedLog(null);
    }
  }, [location?.state, selectedLog, projectNamesData]);
  

  const project = projectNamesData.find((project) => project.project_name === editedLog?.projectname);
  const projectStatus = project ? project.project_status : null;

  const fetchAssignedUsers = async (projectId: any) => {
    try {
      const response = await axios.get(`${BASEURL}/api/assignedusers/${projectId}/?orgid=${orgid}&userid=${userid}`,
        {
          headers: { 'Content-Type': 'multipart/form-data', },
        }
      );
      if (response.status === 200) {
        const assignedUsersList = response.data.users;
        setAssignedUsers(assignedUsersList.map((user: any) => user.username));
        console.log(assignedUsers)
      }
    } catch (error) {
      console.error('Error fetching assigned users:', error);
    }
  };

  const columns: Column[] = [
    { id: 'date', label: 'Date', align: 'left' },
    { id: 'entryby', label: 'Entry By', align: 'left' },
    { id: 'remarks', label: 'Remarks', align: 'left' },
    { id: 'attachments', label: 'Attachments', align: 'left' },
    { id: 'signature', label: 'Signature', align: 'left' },

  ];


  const renderAttachment = (progress: any) => {
    let att1 = getAttachmentsUrl(progress?.attachments)
    let att2 = getAttachmentsUrl(progress?.attachments2)
    let att3 = getAttachmentsUrl(progress?.attachments3)
    let att4 = getAttachmentsUrl(progress?.attachments4)
    let att5 = getAttachmentsUrl(progress?.attachments5)
    let att6 = getAttachmentsUrl(progress?.attachments6)
    return (
      <>
        {att1} {att2 && <br />}
        {att2} {att3 && <br />}
        {att3} {att4 && <br />}
        {att4} {att5 && <br />}
        {att5} {att6 && <br />}
        {att6}
      </>
    );
  }


  const downloadImage = async (imageUrl : string) => {
    const imageUrlPath = BASEURL + '/download_image' ;

    if (imageUrl) {
      try {
        // Fetch the image blob using the imageUrl from the metadata
   //     const response = await axios.get(imageUrlPath, {
        const response = await axios.get(`${imageUrlPath}?image_name=${encodeURIComponent(imageUrl)}`, {
            responseType: 'blob',
        });

        // Create a URL for the blob object
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        const downloadUrl = window.URL.createObjectURL(blob);

        // Extract the filename from the imageUrl
        const fileName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);

        // Create an anchor element and trigger a download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName); // You can also dynamically set the filename here
        document.body.appendChild(link);
        link.click();
        link.remove();  // Clean up by removing the link
      } catch (error) {
        console.error('Failed to download the image:', error);
      }
    }
  };




  const getAttachmentsUrl = (attachmentUrl: string | null) => {
    return attachmentUrl ? (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault(); // Prevent default link behavior
          downloadImage(attachmentUrl); // Call the downloadImage function
        }}
      >
        {attachmentUrl.split('/').pop()} {/* Display file name */}
      </a>
    ) : '';
  };


  function getTodayDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${year}-${month}-${date}`;
  }


  const rowsProgressData = progressUpdates
    .filter(progress => progress.trackingid === editedLog?.id)
    .map(progress => ({
      date: progress.createddate,
      entryby: progress.createdby,
      remarks: progress.remarks,
      /*
            attachments2: progress.attachments ? (
              <a
                href={BASEURL + `/${progress.attachments}`} // Assuming the URL is correct
                // download={progress.attachments.split('/').pop()} // Set download attribute with the file name
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                {progress.attachments.split('/').pop()} 
              </a>
            ) : (''),
      */
      attachments: renderAttachment(progress),
      // signature: progress.initials,
      signature: (
        <span style={{ fontSize: FONT_SIZE }}>
          {progress.initials}
        </span>
      ),
      //    signature: progress.signature ? (<img src={progress.signature} alt="Signature" />) : null

    }));

  rowsProgressData.reverse();

  const handleEditClick = () => {
    setEditedLog((prevState) => ({
      ...prevState!,
      remarks: '',
      attachments: null, attachments2: null, attachments3: null,
      attachments4: null, attachments5: null, attachments6: null,
      signature: '',
      initials: '',
    }));

    setSelectedFiles([]);

    setIsEditMode(true);
  };

  const handleCancelClick = () => {
    setIsEditMode(false);
    /*
     if (selectedLog) {
       setEditedLog(selectedLog as EditedLog);
     } else {
       setEditedLog(null);
     }
 */
  };


  const handleSaveClick = async () => {
    //Function to store the udated data into db
    if (!editedLog) {
      setIsSaving(false);
      return;
    }

    if (editedLog.remarks?.length === 0) {
      toast.error("Please enter Remarks")
      return
    }

    if ((editedLog.initials === undefined || editedLog.initials === "")) {
      toast.error("Signature is Required.")
      return
    }

    setIsLoading(true)
    setIsSaving(true);

    try {
      const editedLogData = {
        createddate: editedLog.createddate,
        title: editedLog.title,
        status: editedLog.status,
        projectname: editedLog.projectname,
        project_id: editedLog.project_id,
        createdby: editedLog.createdby,
        assignedto: editedLog.assignedto,
        description: editedLog.description,
        remarks: editedLog.remarks,
        // atttachments:"",
        //signature : editedLog.signature || null,   // Add the signature data to the log
        initials: editedLog.initials,
      };

      if (!blnChangeFlag) {

        // First, update the selected log
        const response = await axios.put(
          BASEURL + `/dailylogs/${editedLog.id}/`,
          editedLogData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );


        // Check if the user is in edit mode and the log has been successfully updated
        if (isEditMode && response.status === 200) {
          blnChangeFlag = false;
        }
      }

      if ((editedLog.remarks?.length != 0) || selectedFiles[0] !== undefined) {

        // Now, create a progress update with the additional data
        const progressUpdateData = {
          // Include the required data from the edited log
          //        createddate: editedLog.createddate,
          createddate: getTodayDate(),
          createdby: editedLog.createdby,
          remarks: editedLog.remarks,
          attachments: selectedFiles[0] || null,
          attachments2: selectedFiles[1] || null,
          attachments3: selectedFiles[2] || null,
          attachments4: selectedFiles[3] || null,
          attachments5: selectedFiles[4] || null,
          attachments6: selectedFiles[5] || null,
          initials: editedLog.initials,
          trackingid: editedLog.id
        };

        // Make a POST request to create the progress update
        const progressUpdateResponse = await axios.post(
          BASEURL + `/dailylogs/${editedLog.id}/progressupdates/create/`,
          progressUpdateData,
          { headers: { 'Content-Type': 'multipart/form-data', }, }
        );

        // Show success toast messages for both operations
        toast.success("Dailylog details are updated.");
        setIsSaving(false);

        setProgressUpdates(prevProgressUpdates => [...prevProgressUpdates, progressUpdateResponse.data]);
      }
      else
        toast.success('Log details are updated successfully');
      //     } else {
      // If not in edit mode or log update fails, show only log edit success toast
      //       toast.success('Error in updating Log details');
      //    }

      // Exit edit mode
      setIsEditMode(false);
    } catch (error) {
      toast.error('Error saving');
      setIsSaving(false);
    }
    finally {
      setIsLoading(false)
    }
  };

  const handleDialogOpen = () => {
    setAnchorEl(null);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteClick = async () => {
    setOpenDialog(false);
    try {
      const url_delete = BASEURL + `/dailylogs/${editedLog?.id}/`
      await axios.delete(url_delete);
      toast.success('Log deleted successfully');
      navigate('/dailylogs')
      setIsEditMode(false);
    } catch (error) {
      toast.error('Error deleting log');
    }
  };

  const handleBack = () => {
    navigate('/dailylogs')
  }

  //   const handleChange = (
  //     event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  //   ) => {
  //     const { name, value } = event.target;
  //     setEditedLog((prevState) => ({
  //       ...prevState!,
  //       [name]: value,
  //     }));
  //   };

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    let newAttachments: File | null = null;


    if (name !== 'remarks' && name !== 'atachments' && name !== 'initials')
      blnChangeFlag = true;

    if (name === 'attachments' && event.target instanceof HTMLInputElement) {
      const files = event.target.files;
      if (files && files.length > 0) {
        newAttachments = files[0];
      }
    }

    setEditedLog((prevState) => ({
      ...prevState!,
      [name]: name === 'attachments' ? newAttachments : value,
    }));
  };


  const handleProjectNameChange = (event: SelectChangeEvent<string>) => {
    const valueProjectID = parseInt(event.target.value);
    const selProjectNameArray = projectNamesData.find(project => project.id === valueProjectID);

    if (selProjectNameArray) {
      const selProjectName = selProjectNameArray.project_name;

      setEditedLog((prevState) => ({
        ...prevState!,
        projectname: selProjectName,
        project_id: event.target.value
      }));

      // Fetch assigned users for the selected project
      fetchAssignedUsers(valueProjectID);
    }
    blnChangeFlag = true;
  };


  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    setEditedLog((prevState) => ({
      ...prevState!,
      [name]: value,
    }));
    blnChangeFlag = true
  };


  const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files!) as File[]; // Type assertion for clarity

    // Filter out unique files to add
    const uniqueFilesToAdd = newFiles.filter((file) => !selectedFiles.some((selectedFile) => selectedFile.name === file.name));

    if ((uniqueFilesToAdd.length + selectedFiles.length) > 6) {
      // Display an error message or perform any other action to notify the user
      toast.error('You can only upload up to 6 files.');
      return; // Abort further processing
    }

    // Add unique files to the selected files
    setSelectedFiles((prevFiles) => [...prevFiles, ...uniqueFilesToAdd]);

  };



  const handleButtonClick = (evt: any) => {
    evt.preventDefault();

    // Display the error message when the button is clicked
    if (selectedFiles.length > 5)
      toast.error("You can upload maximum of 6 files.")
    else {
      let obj = document.getElementById('fileInput');
      if (obj != null)
        obj.click();
    }
  };


  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  // Add an array of status options
  const statusOptions = ['Pending', 'In progress', 'Completed'];

  // Create a function to render the dropdown menu options
  const renderStatusOptions = () => {
    return statusOptions.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ));
  };


  const handleClearSignature = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
      setSignatureData('');
    }
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>

      <Box>
        <Box sx={{ position: 'relative', top: 0, right: 0, mt: '-70px' }}>
          {!isEditMode ? (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* Daily Log View Heading */}
              <Box >
                <Typography variant='h6' gutterBottom>
                  <Link to={'/dailylogs'} >Daily Log</Link> {ARROW} View
                </Typography>
              </Box>
              {/* Cancel and Save Buttons */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  {/* Edit button */}
                  <div
                    style={{
                      opacity:
                        (moduleAccess !== 'Owner' && moduleAccess !== 'Edit') ||
                          subscriptionstatus !== 'Active' ||
                          projectStatus === 'Completed'
                          ? 0.5
                          : 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (
                          (moduleAccess === 'Owner' || moduleAccess === 'Edit') &&
                          subscriptionstatus === 'Active' &&
                          projectStatus !== 'Completed'
                        ) {
                          handleEditClick();
                        }
                      }}
                      sx={{ mr: 1 }}
                    >
                      Edit
                    </Button>
                  </div>

                  {/* Conditional messages */}
                  <div style={{ marginTop: '4px' }}>
                    {(moduleAccess !== 'Owner' && moduleAccess !== 'Edit') && (
                      <p style={{
                        color: 'gray',
                        fontStyle: 'italic',
                        fontWeight: 'bold',
                        margin: '2px 0'  // Adjust vertical margins for small gap
                      }}>
                        You do not have edit access.
                      </p>
                    )}
                    {subscriptionstatus !== 'Active' && (
                      <p style={{
                        color: 'gray',
                        fontStyle: 'italic',
                        fontWeight: 'bold',
                        margin: '2px 0'  // Adjust vertical margins for small gap
                      }}>
                        Your subscription is expired.
                      </p>
                    )}
                    {projectStatus === 'Completed' && (
                      <p style={{
                        color: 'gray',
                        fontStyle: 'italic',
                        fontWeight: 'bold',
                        margin: '2px 0'  // Adjust vertical margins for small gap
                      }}>
                        This project is completed.
                      </p>
                    )}
                  </div>
                </div>
                {isEditMode && (
                  <>
                    <Button
                      variant='contained'
                      onClick={handleCancelClick}
                      sx={{ mr: 1 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={handleSaveClick}
                      disabled={isSaving}
                    >
                      Save
                    </Button>
                  </>
                )}
              </Box>
            </Box>

          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant='h6' component='div'>
                <Link to={'/dailylogs'} >Daily Log</Link> {ARROW}Edit
              </Typography>
              <Box sx={{ marginLeft: 'auto' }}>
                <IconButton
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  sx={{ marginRight: '30px' }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                >
                  <MenuItem onClick={handleDialogOpen}>Delete</MenuItem>
                </Menu>
              </Box>
              <ConfirmationDialog
                open={openDialog}
                handleClose={handleDialogClose}
                handleConfirm={handleDeleteClick}
                message="Are you sure you wanted to delete this item? This action is irreversible."
                title="Confirm Deletion"
              />
            </Box>)

          }
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '10px',
          }}
        >
          {/* <h2>Selected Log Details</h2> */}
        </Box>
        {editedLog ? (
          <Box sx={{ mt: '-30px' }}>

            <Grid container alignItems="center" spacing={2} sx={{ mt: '30px' }}>
              <Grid item xs={12}>
                <Box>
                  <Grid container alignItems="center" spacing={2}>

                    <Grid item xs={12} sm={6} md={3}>
                      <p><strong>Dailylog Title</strong></p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      {isEditMode ? (
                        <TextField
                          variant='outlined'
                          name='title'
                          value={editedLog?.title || ''}
                          onChange={handleChange}
                          fullWidth
                        />
                      ) : (
                        <Box sx={{ mt: '18px' }}>
                          {editedLog?.title}
                        </Box>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <p><strong>Project Name</strong></p>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      {isEditMode ? (

                        <div>
                          <div>
                            <Box sx={{ mt: "0px", border: '1px solid #000000' }}>
                              <Select
                                value={editedLog?.project_id}
                                onChange={handleProjectNameChange}
                                fullWidth
                                variant="outlined"
                                name="projectname"
                                sx={{ textAlign: "left", textJustify: "center", }}
                              >
                                {/* Map through projectNamesData and render MenuItem for each */}
                                {projectNamesData.filter(project => project.project_status !== 'Completed').map((project, index) => (
                                  <MenuItem key={index} value={project.id}
                                    sx={{
                                      color: '#000000',
                                      fontSize: '18px',
                                    }}>
                                    {project.project_name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Box>
                          </div>


                        </div>
                      ) : (
                        <Box sx={{ mt: '15px' }}>
                          {editedLog?.projectname}
                        </Box>
                      )}

                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <p><strong>Status</strong></p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      {isEditMode ? (
                        <Box sx={{ border: '1px solid #000000' }}>
                          <Select
                            value={editedLog?.status || ''}
                            onChange={handleSelectChange}
                            name='status'
                            variant='outlined'
                            fullWidth
                            sx={{
                              ...AUTOFILL_STYLES(theme),
                            }}
                          >
                            {statusOptions.map((option) => (
                              <MenuItem key={option}
                                value={option}
                                selected={option === editedLog?.status}
                                sx={{
                                  color: '#000000',
                                  fontSize: '18px',
                                }}> {/* Set value to the option */}
                                {option}
                              </MenuItem>))}
                          </Select>
                        </Box>
                      ) : (
                        <Box sx={{ mt: '15px' }}>
                          {editedLog?.status}
                        </Box>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <p><strong>Created By</strong></p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box sx={{ mt: '15px' }}>
                        {editedLog?.createdby}
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <p><strong>Assigned To</strong></p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      {isEditMode ? (

                        <Select
                          value={editedLog.assignedto}
                          onChange={handleSelectChange}
                          fullWidth
                          variant="outlined"
                          name="assignedto"
                          sx={{ textAlign: "left", textJustify: "center", }}
                        >
                          {assignedUsers.map((type: string) => (
                            <MenuItem key={type} value={type}
                              sx={{
                                color: '#000000',
                                fontSize: '18px',
                              }}>
                              {type}
                            </MenuItem>
                          ))}
                        </Select>

                      ) : (
                        <Box sx={{ mt: '15px' }}>
                          {editedLog?.assignedto}
                        </Box>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <strong>Created Date </strong>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box sx={{ mt: '15px' }}>
                        {editedLog?.createddate}
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <p><strong>Description</strong>{isEditMode ? ' (optional)' : ''}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      {isEditMode ? (
                        <TextField
                          variant='outlined'
                          name='description'
                          value={editedLog?.description || ''}
                          onChange={handleChange}
                          multiline  // Enable multiline
                          rows={5}
                          sx={{}}
                          fullWidth
                        />
                      ) : (
                        <Box sx={{ mt: '15px' }}>
                          {editedLog?.description}
                        </Box>
                      )}
                    </Grid>
                    {isEditMode && (
                      <Grid item xs={12} sm={6} md={3}>
                        <p><strong>Remarks</strong></p>
                      </Grid>)}
                    <Grid item xs={12} sm={6} md={3}>
                      {isEditMode && (
                        <TextField
                          variant='outlined'
                          name='remarks' multiline rows={5}
                          onChange={handleChange}
                          sx={{
                            ...AUTOFILL_STYLES(theme),
                          }}
                          fullWidth
                        />
                        // ) : (
                        //     <Box sx={{mt:'17px'}}>
                        //   {selectedLog.remarks}
                        //   </Box>
                      )}
                    </Grid>
                    {isEditMode && (
                      <Grid item xs={12} sm={6} md={3}>
                        <p><strong>Attachments</strong>{isEditMode ? ' (optional)' : ''}</p>
                      </Grid>)}
                    <Grid item xs={12} sm={6} md={3}>
                      {isEditMode && (
                        <div>
                          <input id="fileInput"
                            type="file"
                            name="file"
                            onChange={handleFilesChange}
                            accept=".jpg, .jpeg, .png, .PNG"
                            multiple
                            style={{ display: 'none' }}
                          />
                          <Button variant='contained' color='primary' onClick={handleButtonClick}>Browse</Button>
                        </div>
                      )}

                      {isEditMode && (
                        selectedFiles.map((file: any) => (
                          <div key={file.name}>
                            <Grid mt={1} container spacing={0} sx={{ mt: 1 }}>
                              <Grid item md={6} xs={12} sx={{ wordWrap: 'break-word' }}>
                                <span style={{ display: 'block', overflowWrap: 'break-word' }}>{file.name}</span>
                              </Grid>
                              <Grid item md={3} xs={12} style={{ marginLeft: '0px' }}>
                                <Button color='error'
                                 variant='text' onClick={() => handleRemoveFile(file.name)}
                                 sx={{ mt: { xs: 1, md: 0 } }}>Remove</Button>
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      )}
                    </Grid>

                    {isEditMode && (
                      <>
                        <Grid item xs={12} sm={6} md={3}>
                          <p><strong>Signature</strong></p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                          {isEditMode && (
                            <div style={{
                              display: 'flex', flexDirection: 'column', border: '1px solid #ccc',
                              paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 0,
                            }}> {/* Wrap Sign in flex container with column layout and border */}
                              <TextField
                                name={'initials'} type={'text'} value={editedLog ? editedLog['initials'] : ''}
                                onChange={handleChange}
                                fullWidth margin='dense' variant='outlined'
                                sx={{
                                  ...AUTOFILL_STYLES(theme),
                                }}
                              />

                              <span style={{
                                fontFamily: SIGN_FONT, minHeight: '50px', maxWidth: '100#', whiteSpace: 'pre-wrap',
                                fontSize: FONT_SIZE, border: '2px solid #ccc', padding: 5
                              }}>
                                {editedLog ? editedLog['initials'] : ''}
                              </span>
                            </div>
                          )}
                        </Grid>
                      </>
                    )}

                  </Grid>
                </Box>
              </Grid>
            </Grid>

            {isEditMode && (<Box sx={{ mt: '50px', display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant='contained' onClick={handleSaveClick} sx={{ marginRight: '20px', width: '75px', '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }} disabled={isSaving}>
                Save
              </Button>
              <Button
                variant='contained'
                onClick={handleCancelClick}
                sx={{ marginRight: '10px', width: '75px' }}
              >
                Cancel
              </Button>

            </Box>)}

            {/*  -----------------code for progress table starts here--------------------*/}

            <h3 style={{ marginTop: '60px' }}>Progress Update</h3>
            <Box sx={{ marginTop: '30px', ml: '-35px', mr: '-40px' }}>
              <BasicTable columns={columns} rows={rowsProgressData} />
            </Box>
          </Box>

        ) : (
          <p>No log selected</p>
        )}
      </Box>
      <FloatingButton />
    </ThemeProvider>
  );
};

export default DailyLogEdit;